<div class="row">
  <div class="column small-12 small-12 large-12 index-footer">
    <h1 class="index-footer-title"
        *ngIf="appCfg.conf.ui.footerTitle"
        [innerHTML]="appCfg.conf.ui.footerTitle"></h1>
    <div class="index-footer-txt"> {{'DEVELOPED_BY_X' | translate | sprintf:('Heitz System ® ' + currentYear) }} </div>
  </div>
</div>
